export default function ExerciseHistory({ userProgramDayExercisesAttempt }) {
  const userProgramDayExercisesAttemptWithNotes =
    userProgramDayExercisesAttempt?.filter(
      (exercise) => exercise.note && exercise.note.trim() !== ""
    ) || [];

  if (userProgramDayExercisesAttemptWithNotes.length === 0) {
    return <></>;
  }

  return (
    <div className="my-3 my-md-5">
      <h4 className="my-2 my-md-3">Notes Feed:</h4>
      <ul>
        {userProgramDayExercisesAttemptWithNotes.map((exercise, index) => (
          <li key={index} className="mb-3 pb-2">
            <div>
              <div className="mb-2 text-muted">
                {exercise.updated_at
                  ? new Date(exercise.updated_at).toLocaleString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                    })
                  : ""}
                {`;  Set #${index + 1}`}
              </div>
              <div className="chat-bubble last-no-border">
                <p className="chat-bubble-text">{exercise.note}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
